import { styles } from './template.scss';
import { styles as commonImStyles } from '../../common/common.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../assets/text-helpers.scss';

export const templateImDefaultRuleConfiguration = document.createElement('template');

templateImDefaultRuleConfiguration.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${commonImStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>

    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>

    <div class='form-wrapper'>
      <div class='form-section'>
         <div class=' mb-2' id='general-title-section'>
           <gz-title fontSize='18' class='title' id='general-title'></gz-title>
           <gz-link id='learn-more'></gz-link>
         </div>

        <gz-labeled-content id='name' labelfontsize='13' hasFormLabelWidth='true'></gz-labeled-content>
        <gz-labeled-content id='description' labelfontsize='13' hasFormLabelWidth='true'></gz-labeled-content>
        <gz-labeled-content id='severity' labelfontsize='13' hasFormLabelWidth='true'></gz-labeled-content>
        <gz-labeled-content id='type' labelfontsize='13' hasFormLabelWidth='true'></gz-labeled-content>
        <gz-labeled-content id='created-on' labelfontsize='13' hasFormLabelWidth='true'></gz-labeled-content>
        <gz-labeled-content id='modified-on' labelfontsize='13' hasFormLabelWidth='true'></gz-labeled-content>
      </div>

      <div class='form-section'>
        <gz-title fontSize='18' class='title mb-2' id='details-title'></gz-title>

        <gz-labeled-content id='entity-types' labelfontsize='13' hasFormLabelWidth='true'></gz-labeled-content>
        <gz-labeled-content id='mitre-ids' labelfontsize='13' hasFormLabelWidth='true'></gz-labeled-content>
      </div>

      <div class='form-section' id='configuration-section'>
        <gz-title fontSize='18' class='title mb-2' id='configuration-title'></gz-title>

         <gz-form-list id='configuration-form-fields' useMinWidth useLargeInput></gz-form-list>
      </div>

      <div class='form-section'>
        <gz-title fontSize='18' class='title mb-2' id='assignation-title'></gz-title>

        <gz-labeled-content id='policies' labelfontsize='13' hasFormLabelWidth='true' clampLine='true'></gz-labeled-content>
        <gz-labeled-content id='rule-sets' labelfontsize='13' hasFormLabelWidth='true' clampLine='true'></gz-labeled-content>
      </div>
    </div>

    <div class='bottom-buttons'>
      <gz-button id='saveButton' disabled></gz-button>
      <div class='flex-auto'></div>
      <gz-button id='cancelButton' type='outline' color='secondary'></gz-button>
    </div>
  </div>
`;
